import { ApiUnreachableError } from '@/api/client'

/**
 * Retry policy shared by the app's real QueryClient (App.tsx) and exercised
 * directly by tests. ApiUnreachableError (see api/client.ts) is frequently a
 * transient race right after a Cloudflare Access redirect back into the app
 * - the API origin's own Access session can take a moment to finish
 * propagating, so the first request or two after landing on a page can fail
 * with the exact same "unreachable" signature a real outage would produce,
 * and self-heal a couple hundred ms later. A single generic retry isn't
 * reliably enough attempts to ride that out; every other error keeps the
 * original budget.
 */
export function shouldRetryQuery(failureCount: number, error: unknown): boolean {
  return error instanceof ApiUnreachableError ? failureCount < 4 : failureCount < 1
}
